import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Form, Col, Button, FormLabel, Spinner, Row, Container } from "react-bootstrap";

// import logo_black from "";
import eye from "../../images/eye.svg";
import signBanner from "../../images/signBanner.svg";
import logo from "../../images/logoinwhite.png";
import gmail from "../../images/gmail.svg";
import fbicon from "../../images/fbicon.svg";
import twittericon from "../../images/twittericon.svg";
import { API_BASE_URL, BRAND_NAME } from '../../functions';
import { useAuth } from './auth/AuthProvider';
import toast from 'react-hot-toast';
import MyCarousel from '../PublicPages/componnents/MyCarousel';
import Footer2 from '../PublicPages/componnents/Footer2';

const SignIn3 = ({ setIsAuthenticated }) => {

  const [email, setemail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordType, setPasswordType] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { updateToken } = useAuth();

  const Navigate = useNavigate()
  useEffect(() => {
    let isLogin = localStorage.getItem('token');
    if (isLogin) {
      Navigate('/dashboard');
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        // localStorage.setItem('token', JSON.stringify(data.success));
        updateToken(data.success);
        (data?.success?.role === 'admin' ? Navigate('/dashboard') : Navigate('/dashboard'))
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Something went wrong. Please try again later');
      }

    } catch (error) {
      toast.error(error.response.data.message)
      setError('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // console.log(passwordType);
  return (
    <>
      <>
        <nav className="navbar navbar-expand-lg navbar-light fixed-top">
          <div className="container">
            <Link to={'/'} className={'d-block'}><img className={'img-fluid'} src={logo} alt={'icon'} /></Link>
            <Form className="" onSubmit={(e) => handleLogin(e)}>
              <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item mx-1">
                    <Form.Group>
                      <div className="wrap-input100 validate-input" data-validate="Email Address">
                        <input className="input100" placeholder="xyz@company.com" required type="email" autoComplete="on" id="email" name="email" value={email} onChange={(e) => setemail(e.target.value)} />
                        <span className="focus-input100"></span>
                      </div>
                    </Form.Group>
                  </li>

                  <li className="nav-item mx-1">
                    <Form.Group>
                      <div className="wrap-input100 validate-input" data-validate="Password is required">
                        <input className="input100" type={passwordType ? "password" : "text"} id="password" required placeholder="Password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        <span className="focus-input100"></span>
                        <span className="focus-input100-img"><img className="img-fluid" src={eye} alt="eye" onClick={() => setPasswordType(!passwordType)} /></span>
                      </div>
                    </Form.Group>
                    {error && <div className="whitetext mb-2">{error}</div>}
                  </li>

                  <li className="nav-item mx-1">
                    <Button variant="" type="submit" id="submit" className="login100-form-btn3 brandMainColorBg" disabled={loading}>{!loading ? 'Login' : <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />}</Button>
                  </li>
                  <li className="nav-item mx-1">
                    {/* <Button variant="" className="login100-form-btn3 greenbg" >Register</Button> */}
                    <Link to={'/signup'} className="login100-form-btn3 greenbg"> Register</Link>
                  </li>
                </ul>
              </div>
            </Form>
          </div>
        </nav>

        <header className="masthead text-white text-center">
          <div className="overlay"></div>
          <Container className='singinviews'>
            <Row className="justify-content-md-center mt-5">
              <Col className='loginform' xs={12} md={6}>
                <Form className="validate-form w-100 text-center" onSubmit={(e) => handleLogin(e)}>
                  <span className="login100-form-title">Log In to {BRAND_NAME}</span>
                  <Col xl={12} className="mb-4 mt-5">
                    <Form.Group>
                      <div className="wrap-input100 validate-input" data-validate="Email Address">
                        <input className="input100" placeholder="xyz@company.com" required type="email" autoComplete="on" id="email" name="email" value={email} onChange={(e) => setemail(e.target.value)} />
                        <span className="focus-input100"></span>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mb-3">
                    <Form.Group>
                      <div className="wrap-input100 validate-input" data-validate="Password is required">
                        <input className="input100" type={passwordType ? "password" : "text"} id="password" required placeholder="Password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        <span className="focus-input100"></span>
                        <span className="focus-input100-img"><img className="img-fluid" src={eye} alt="eye" onClick={() => setPasswordType(!passwordType)} /></span>
                      </div>
                    </Form.Group>
                  </Col>
                  <div className="d-flex align-items-center mb-4">
                    <div className="contact100-form-checkbox">
                      <Form.Group className="mb-0 d-flex align-items-center">
                        <Form.Check />
                        <FormLabel label="inputPassword5" className="m-0 ms-3">Remind me</FormLabel>
                      </Form.Group>
                    </div>
                    <p className="ms-auto"><Link to={'/forgot'} className="txt1">Forgot password?</Link></p>
                  </div>
                  {error && <div className="redtext mb-2">{error}</div>}
                  <Button variant="" type="submit" id="submit" className="login100-form-btn" disabled={loading}>{!loading ? 'Login' : <Spinner as='span' animation='border' size='md' role='status' aria-hidden='true' />}</Button>
                  <p className="mt-4 text-center">Don't have an account?<Link to={'/signup'} className="fontweight600 primarycolor fontsize14"> Register</Link></p>
                </Form>
              </Col>
            </Row>
          </Container>
          <div className="container singinview">
            <div className="row">
              <div className="col-xl-6 col-md-8 col-lg-6 col-sm-12 text-left  mx-auto">
                <h3 className='wantto mb-3'>
                  Want to Become
                </h3>
                <h1
                  className="mb-5 atravel"
                >
                  A Travel Agent ?
                </h1>
              </div>

              <div className="col-md-10 col-lg-10 col-xl-10 mx-auto">
                <MyCarousel />
              </div>
            </div>
          </div>
        </header>
        <Footer2/>
        {/* <footer className="footer bg-light">
          <div className="container">
            <p className="text-muted small mb-0">
              Coded by: Giuseppe Mele
            </p>
          </div>
        </footer> */}
      </>
    </>
  )
}

export default SignIn3;